module.exports = __webpack_public_path__ + "static/media/bullet.82916798.svg";